<template>
  <LegalPage page="terms">
    <h1>Terms of Service</h1>
    <p class="last-updated">Last Updated: September 14, 2026</p>

    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using InstaSave
        (<a href="https://instasaves.io/">https://instasaves.io/</a>), you agree to comply
        with and be bound by these Terms of Service. If you do not agree with any part of
        these terms, please do not use our website.
      </p>
    </section>

    <section>
      <h2>2. Permitted Use</h2>
      <p>
        InstaSave is provided for personal, non-commercial use only. Users are solely
        responsible for ensuring that their download activities comply with local copyright
        laws, intellectual property regulations, and Instagram's terms of service. You agree
        not to download, redistribute, or use any media content for commercial purposes
        without explicit authorization from the original content creator.
      </p>
    </section>

    <section>
      <h2>3. Limitation of Liability</h2>
      <p>
        InstaSave is provided on an "AS IS" and "AS AVAILABLE" basis without any warranties
        of any kind, express or implied. We do not guarantee uninterrupted or error-free
        operation. InstaSave shall not be held liable for any direct, indirect, or
        consequential damages or copyright infringements arising from your use of this tool.
      </p>
    </section>

    <section>
      <h2>4. Third-Party Links &amp; Content</h2>
      <p>
        Our website may contain links to third-party websites. We have no control over and
        assume no responsibility for the content, privacy policies, or practices of any
        third-party sites or services.
      </p>
    </section>

    <section>
      <h2>5. Disclaimer of Endorsement</h2>
      <p>
        InstaSave is an independent tool and is not endorsed by, directly affiliated with,
        maintained, authorized, or sponsored by Meta Platforms, Inc. or Instagram.
      </p>
    </section>
  </LegalPage>
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Terms',
  components: {
    LegalPage
  }
};
</script>
